<script setup lang="ts">

</script>

<template>
  <div class="container mx-auto px-12 mt-6 bg-white rounded-lg grid md:grid-cols-4 gap-4 items-center justify-center">
    <div class="flex justify-center items-center mb-4 md:mb-0">
      <NuxtImg widt="284" height="284" src="/img/cats.webp" lazy alt="Готовы стать нашим клиентом" />
    </div>
    <div class="text-center w-full md:col-span-2">
      <h2 class="text-2xl font-bold text-title mb-2">
        Готовы стать нашим клиентом?
      </h2>
      <p class="text-gray-600">
        Заполните заявку прямо сейчас и получите мгновенный денежный перевод!
      </p>
    </div>
    <div class="flex items-center justify-center w-full">
      <GradientButton class="w-full text-xl">
        Оставить заявку
      </GradientButton>
    </div>
  </div>
</template>

<style scoped>

</style>
